// extracted by mini-css-extract-plugin
export default {"headerContainer":"FilesHeader_headerContainer__FGncg","actions":"FilesHeader_actions__gGj07"};